import { combineReducers } from 'redux';

import { DUPLICATE_MODAL_TYPE } from 'constants/InterventionConstants';
import {
  POST_DUPLICATE_INTERVENTION,
  POST_DUPLICATE_INTERVENTION_SUCCESS,
  POST_DUPLICATE_INTERVENTION_FAILURE,
  OPEN_DUPLICATE_MODAL,
  CLOSE_DUPLICATE_MODAL,
} from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  isLoading: boolean,
 *  isVisible: boolean,
 *  error: any,
 *  visibility: {
 *      DUPLICATE: boolean,
 *      SEND_AS_MESSAGE: boolean,
 *      BODYWORK: boolean,
 *  }
 * }} DuplicateModalState
 */

const initialState = {
  [DUPLICATE_MODAL_TYPE.BODYWORK]: false,
  [DUPLICATE_MODAL_TYPE.DUPLICATE]: false,
  [DUPLICATE_MODAL_TYPE.SEND_AS_MESSAGE]: false,
};

export default combineReducers({
  isLoading: createReducer(false, {
    [POST_DUPLICATE_INTERVENTION]: () => true,
    [POST_DUPLICATE_INTERVENTION_SUCCESS]: () => false,
    [POST_DUPLICATE_INTERVENTION_FAILURE]: () => false,
  }),
  error: createReducer(null, {
    [POST_DUPLICATE_INTERVENTION]: () => null,
    [POST_DUPLICATE_INTERVENTION_FAILURE]: (_, action) => action.payload,
  }),
  // Deprecated isVisible (kept for compatibility if needed, but visibility is now managed per type)
  isVisible: createReducer(false, {
    [OPEN_DUPLICATE_MODAL]: () => true,
    [CLOSE_DUPLICATE_MODAL]: () => false,
    [POST_DUPLICATE_INTERVENTION_SUCCESS]: () => false,
  }),
  visibility: createReducer(initialState, {
    [OPEN_DUPLICATE_MODAL]: (state, { payload }) => ({
      ...state,
      [payload]: true,
    }),
    [CLOSE_DUPLICATE_MODAL]: () => initialState,
    [POST_DUPLICATE_INTERVENTION_SUCCESS]: () => initialState,
  }),
});
